module.exports = __webpack_public_path__ + "90c38985532899f2b877cd1510f088b0.svg";